import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CybersourceModalService {
	private dataPay: any;
	private currentDataPay = new BehaviorSubject(this.dataPay);
	private fraudType = new BehaviorSubject(null);

	constructor() {
	}

	sendDataPayment(dataPayment, idOperation, fraudType) {
		this.dataPay = Object.assign(dataPayment, { idOperation: idOperation });
		this.currentDataPay.next(this.dataPay);
		this.fraudType.next(fraudType);
	}

	getObject() {
		return this.currentDataPay.asObservable();
	}
	
	getFraudType() {
		return this.fraudType.asObservable();
	}
	
	reset() {
		this.dataPay = null;
		this.currentDataPay.next(this.dataPay);
		this.fraudType.next(null);
	}
}
